import React from 'react';

import { CustomerData } from '@/sections/customerManagement/types';
import Avatar from '@/sections/topNavBar/Avatar';

interface CustomerNameWithLogoProps {
  customer: CustomerData;
}

export const CustomerNameWithLogo: React.FC<CustomerNameWithLogoProps> = ({
  customer,
}) => {
  // Display name as-is from the database - no formatting applied
  // The display name is fetched from the settings object with key 'display-name'
  // If no custom name is set, it will fall back to the email (handled by useCustomerDisplayName)
  const displayName = customer.displayName || customer.email;

  return (
    <div className="flex items-center gap-3">
      <div className="size-8 flex-shrink-0">
        <Avatar
          email={customer.email}
          className="size-8 rounded-full object-cover"
        />
      </div>
      <div className="flex min-w-0 flex-col">
        <span className="text-chariot-text-primary truncate text-sm font-medium">
          {displayName}
        </span>
        <span className="text-chariot-text-secondary truncate text-xs">
          {customer.email}
        </span>
      </div>
    </div>
  );
};
